/**
 * Landing-page hero copy. Kept in its own module (like customer.ts / offline.ts) so the two central
 * strings an elderly resident actually reads are in one visible place rather than buried in the
 * 10,000-line inline catalogues.
 *
 * trackQuestion is the single question the page now asks: the one thing a resident arrives to answer.
 * staffEntry is the discreet door to the staff apps, deliberately phrased as a question about the
 * person's job so a resident does not read it as something meant for him.
 */
export const homeExtraMessages = {
  fr: {
    trackQuestion: 'Où est mon colis ?',
    staffEntry: 'Vous travaillez avec 3asass ?',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    ssoSigningIn: 'Connexion en cours...',
    ssoBack: 'Retour à la connexion',
    ssoNoToken: 'Aucun jeton de connexion reçu.',
    ssoFailed: 'La connexion a échoué.',
    codLabel: 'Paiement à la livraison'
  },
  en: {
    trackQuestion: 'Where is my parcel?',
    staffEntry: 'Do you work with 3asass?',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    ssoSigningIn: 'Signing you in...',
    ssoBack: 'Back to sign in',
    ssoNoToken: 'No sign-in token was received.',
    ssoFailed: 'Sign-in failed.',
    codLabel: 'Cash on delivery'
  },
  ar: {
    trackQuestion: 'أين طردي؟',
    staffEntry: 'هل تعمل مع 3asass؟',
    showPassword: 'إظهار كلمة المرور',
    hidePassword: 'إخفاء كلمة المرور',
    ssoSigningIn: 'جاري تسجيل الدخول...',
    ssoBack: 'العودة إلى تسجيل الدخول',
    ssoNoToken: 'لم يتم استلام رمز تسجيل الدخول.',
    ssoFailed: 'فشل تسجيل الدخول.',
    codLabel: 'الدفع عند التسليم'
  },
  ma: {
    trackQuestion: 'فين الكولي ديالي؟',
    staffEntry: 'واش كتخدم مع 3asass؟',
    showPassword: 'بين الباسوورد',
    hidePassword: 'خبي الباسوورد',
    ssoSigningIn: 'كنسجلو الدخول ديالك...',
    ssoBack: 'رجع لتسجيل الدخول',
    ssoNoToken: 'ما جا حتى توكن د الدخول.',
    ssoFailed: 'تسجيل الدخول ما نجحش.',
    codLabel: 'الخلاص عند التسليم'
  }
}
